/**
 * 购物车商品模块
 */
import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useIonViewDidEnter } from '@ionic/react'
import { cartMobx } from 'mobx/mall'
import { localStore } from '@utils'
import CartProductItem from '../CartItem'
import './index.scss'

const CartProduct: FC = () => {
  useIonViewDidEnter(() => {
    if (!localStore.get('userInfoTips')) {
      const tipWrapper = document.getElementById('tipPop')
      tipWrapper && tipWrapper.click()
    }
  })

  return (
    <div className='mall-cart-product-wrapper'>
      {
        cartMobx.viewCartItems && (
          <section>
            {cartMobx.viewCartItems
              .filter((item) => item.cnt && !item.disabled)
              .map((cartItem, index) => (
                <div key={cartItem.pk}>
                  <CartProductItem cartItem={cartItem} index={index} />
                </div>
              ))}
          </section>
        )
      }
      {!!cartMobx.viewDisabledCartItems.length && (
        cartMobx.viewDisabledCartItems.map((cartItem, index) => (
          <div key={cartItem.pk}>
            <CartProductItem cartItem={cartItem} index={index} disabled={!!1} />
          </div>
        ))
      )}
    </div>
  )
}

export default observer(CartProduct)
